import { render, staticRenderFns } from "./MinimizedCall.vue?vue&type=template&id=39d3899b"
import script from "./MinimizedCall.vue?vue&type=script&lang=js"
export * from "./MinimizedCall.vue?vue&type=script&lang=js"
import style0 from "./MinimizedCall.vue?vue&type=style&index=0&id=39d3899b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports